import React from 'react';
import { PersonalLayout } from '../components/PersonalLayout';
import { AssetsLiabilitiesSection } from '../components/AssetsLiabilitiesSection';
import { CurrencyToggle } from '../components/CurrencyToggle';
import { useEntityStore, usePortfolioPrefsStore, PERSONAL_VIEW_OPTIONS } from '../store';

// Restructured: adopts the entities dashboard layout pattern.
// The standalone "Assurance Vie" section is gone; assurance vie items
// appear as a category inside Assets & Liabilities.

export function PersonalNetWorthPage() {
  const personalView = useEntityStore((s) => s.personalView);
  const displayCurrency = usePortfolioPrefsStore((s) => s.displayCurrency);

  return (
    <PersonalLayout>
      <div className="space-y-6 p-4 md:p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">
              Assets & Liabilities
            </h1>
            <p className="text-muted-foreground mt-1">
              {PERSONAL_VIEW_OPTIONS.find((v) => v.key === personalView)?.shortLabel ?? 'Personal'}
            </p>
          </div>
          <CurrencyToggle />
        </div>

        <AssetsLiabilitiesSection scope="personal" displayCurrency={displayCurrency} />
      </div>
    </PersonalLayout>
  );
}
